var loaderHidden = false; // Flag to track loader visibility
var minimumLoaderTime = 500; // Minimum time to display the loader in milliseconds
var loaderStartTime; // Time when loader starts

function handleLoadingAnimation() {
    var totalElements = $('img').length + ($('video').length ? 1 : 0);
    var loadedElements = 0;

    // Record the start time of the loader
    loaderStartTime = new Date().getTime();

    // Function to hide the loader
    function hideLoader() {
        var currentTime = new Date().getTime();
        var elapsedTime = currentTime - loaderStartTime;

        if (!loaderHidden && elapsedTime >= minimumLoaderTime) {
            $(".loader-wrapper").fadeOut("slow");
            loaderHidden = true;
        } else if (!loaderHidden) {
            setTimeout(hideLoader, minimumLoaderTime - elapsedTime);
        }
    }

    // Update the animation based on loading progress
    function updateAnimationProgress() {
        var progress = loadedElements / totalElements;
        var clipPathValue = `inset(0 ${100 - (progress * 100)}% 0 0)`;
        $(".loader .shadow-image").css("clip-path", clipPathValue);
        var scaleValue = loadedElements < totalElements ? 1.1 : 1;
        $(".loader .shadow-image").css("transform", `scale(${scaleValue})`);
    }

    // When all elements are loaded
    function completeLoading() {
        $(".loader .shadow-image").addClass('loaded');
        hideLoader();
    }

    // Event listener for image and video load
    $('img').on('load', function() {
        loadedElements++;
        if (loadedElements === totalElements) {
            completeLoading();
        } else {
            updateAnimationProgress();
        }
    }).each(function() {
        if (this.complete) {
            $(this).trigger('load');
        }
    });

    var video = $('video').get(0);
    if (video) {
        video.oncanplaythrough = function() {
            loadedElements++;
            if (loadedElements === totalElements) {
                completeLoading();
            } else {
                updateAnimationProgress();
            }
        };
        if (video.readyState >= 4) {
            $(video).trigger('canplaythrough');
        }
    } else {
        loadedElements++;
        if (loadedElements === totalElements) {
            completeLoading();
        } else {
            updateAnimationProgress();
        }
    }

    // Initial state of the loader
    $(".loader-wrapper").fadeIn("slow");
    updateAnimationProgress();
}

// Reset and show the loader when starting navigation
function resetAndShowLoader() {
    loaderHidden = false;
    $(".loader-wrapper").show();
    $(".loader .shadow-image").removeClass('loaded');
    handleLoadingAnimation();
}

// Call the loading animation function when the page starts loading
$(document).ready(function() {
    handleLoadingAnimation();
});

// Hide loader on initial full page load
$(window).on("load", function() {
    loaderHidden = true; // Ensure loader is marked as hidden
    $(".loader-wrapper").fadeOut("slow");
});

// Reinitialize on Shopify's AJAX page load
$(document).on('page:load page:change', function() {
    loaderHidden = false; // Reset loader visibility for AJAX pages
    resetAndShowLoader();
});
